import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { ConfigService } from './config/config.service';

export const ERROR = 'ERROR';
export const WARNING = 'WARNING';
export const INFO = 'INFO';

@Injectable()
export class LoggerService {
  constructor(private configService: ConfigService) {}

  log(message: string, object?: any, level?: string) {
    if (!this.configService.configLoaded || this.configService.config.logging.enableConsoleLog) {
      console.log(`${level ? level : INFO}: ${message}\n`, object);
    }
    if (this.configService.configLoaded && this.configService.config.sentry.allow) {
      if (object instanceof Error) {
        Sentry.captureException(object);
      } else {
        Sentry.captureMessage(message);
      }
    }
  }

  error(message: string, object?: any) {
    this.log(message, object, ERROR);
  }

  warning(message: string, object?: any) {
    this.log(message, object, WARNING);
  }
}

export function initSentry(configService: ConfigService): void {
  const config = configService.config;
  
  if (!config.sentry.allow) {
    return;
  }
  
  var integrations = [
    Sentry.browserTracingIntegration()
  ];
  if (config.sentry.allowReplay == true) {
    integrations.push(Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }));
  }
  
  Sentry.init({
    dsn: config.sentry.dsn,
    integrations: integrations,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: config.environment,
    release: config.appVersion
  });
}

@NgModule({
  imports: [CommonModule],
  providers: [LoggerService],
})
export class LoggerModule {}
